export default {
  // Common / Navigation
  site_name: "CSSBuyBR",
  nav_spreadsheet: "CSSBuy Spreadsheet",
  nav_categories: "Kategorien",
  nav_guides: "Guides",
  nav_reviews: "Reviews",
  nav_shipping: "Versand",
  nav_safety: "Sicherheit",
  nav_home: "Startseite",
  nav_shopping_guide: "Einkaufsführer",
  nav_about: "Über uns",
  language: "Sprache",
  lang_pt: "Português",
  lang_de: "Deutsch",
  lang_en: "English",
  open_spreadsheet: "Spreadsheet öffnen",
  main_cta: "CSSBuy Spreadsheet",
  buy_now: "Buy It Now",
  search_placeholder: "Im CSSBuy Spreadsheet suchen...",
  updated: "Aktualisiert",
  independent_notice: "Unabhängige Ressource",
  disclaimer_short: "Nicht die offizielle CSSBuy-Website",
  read_more: "Mehr lesen",
  explore: "Erkunden",
  learn_more: "Mehr erfahren",
  back_to_home: "Zurück zur Startseite",
  related_articles: "Verwandte Artikel",
  table_of_contents: "Inhaltsverzeichnis",
  author: "Autor",
  published: "Veröffentlicht",
  last_updated: "Zuletzt aktualisiert",
  quick_answer: "Kurzantwort",
  conclusion: "Fazit",
  faq: "Häufig gestellte Fragen",
  pros: "Vorteile",
  cons: "Nachteile",
  step_by_step: "Schritt für Schritt",
  what_youll_learn: "Was Sie lernen werden",
  trust_badge: "Unabhängige Informationen • Praktische Guides • Organisierte Daten",
  safety_cta: "CSSBuy Sicherheitsguide",
  footer_about: "Über uns",
  footer_safety: "Sicherheit",
  footer_disclaimer: "Disclaimer",
  footer_privacy: "Datenschutz",
  footer_terms: "Nutzungsbedingungen",
  footer_contact: "Kontakt",
  footer_resources: "Ressourcen",
  footer_copyright: "© 2026 CSSBuyBR.info. Unabhängige Ressource — nicht die offizielle CSSBuy-Website.",
  disclaimer_full: "CSSBuyBR.info ist eine unabhängige Informationsressource und nicht die offizielle CSSBuy-Website. Wir verarbeiten keine Zahlungen, verkaufen keine Produkte und sind nicht mit CSSBuy verbunden. Überprüfen Sie wichtige Kontoinformationen, Zahlungen, Versand und Richtlinien immer über die offiziellen Kanäle, bevor Sie Maßnahmen ergreifen.",
  
  // Hero
  hero_eyebrow: "CSSBUY • SPREADSHEET • KAUFGUIDES",
  hero_title: "CSSBuy Spreadsheet: Produkte finden und mit mehr Vertrauen kaufen",
  hero_subtitle: "Erkunden Sie ein nach Kategorien organisiertes CSSBuy Spreadsheet und finden Sie praktische Guides zu Produkten, QC, Lagerung, Versandkosten, Gutscheinen und dem Kaufprozess.",
  hero_cta_primary: "CSSBuy Spreadsheet erkunden",
  hero_cta_secondary: "CSSBuy Guides ansehen",
  hero_trust: "Unabhängige Ressourcen • Praktische Guides • Organisierte Informationen",
  
  // Categories Section
  categories_title: "Produktkategorien",
  categories_subtitle: "Navigieren Sie durch beliebte Kategorien und finden Sie, was Sie im CSSBuy Spreadsheet suchen.",
  category_shoes: "Schuhe",
  category_hoodies: "Hoodies/Pullover",
  category_tshirts: "T-Shirts",
  category_jackets: "Jacken",
  category_pants: "Hosen/Shorts",
  category_headwear: "Kopfbedeckung",
  category_sets: "Sets",
  category_underwear: "Unterwäsche",
  category_jersey: "Jerseys",
  category_accessories: "Accessoires",
  category_bags: "Taschen",
  category_belts: "Gürtel",
  category_perfumes: "Parfums",
  category_other: "Sonstiges",
  
  // Spreadsheet Section
  spreadsheet_title: "CSSBuy Spreadsheet an einem Ort",
  spreadsheet_desc: "Produkte zu finden kann schwierig sein, wenn Informationen über verschiedene Quellen verstreut sind. Unser Ziel ist es, Kategorien, Ressourcen und Guides rund um CSSBuy Spreadsheet zu organisieren, um Ihre Recherche zu vereinfachen und Ihnen zu helfen, fundiertere Entscheidungen zu treffen.",
  spreadsheet_card_products: "Produkte",
  spreadsheet_card_products_desc: "Erkunden Sie organisierte Produkte und Kategorien.",
  spreadsheet_card_guides: "Guides",
  spreadsheet_card_guides_desc: "Lernen Sie, wie Sie recherchieren, vergleichen und Informationen überprüfen.",
  spreadsheet_card_shipping: "Versand",
  spreadsheet_card_shipping_desc: "Verstehen Sie Kosten, Gewicht, Optionen und Faktoren, die den Versand beeinflussen.",
  spreadsheet_card_safety: "Sicherheit",
  spreadsheet_card_safety_desc: "Lernen Sie, Links, Angebote und potenziell verdächtige Informationen zu erkennen.",
  spreadsheet_cta: "Kategorien erkunden",
  
  // How It Works
  how_title: "So verwenden Sie ein CSSBuy Spreadsheet",
  how_step1_title: "Produkt finden",
  how_step1_desc: "Suchen Sie nach Kategorie und identifizieren Sie relevante Optionen.",
  how_step2_title: "Informationen prüfen",
  how_step2_desc: "Überprüfen Sie Links, Bilder, Maße und verfügbare Details.",
  how_step3_title: "Optionen vergleichen",
  how_step3_desc: "Konsultieren Sie QC und vergleichen Sie verschiedene Alternativen.",
  how_step4_title: "Entscheidung treffen",
  how_step4_desc: "Bestätigen Sie Preise, Richtlinien und aktuelle Informationen vor dem Kauf.",
  how_cta: "CSSBuy Spreadsheet öffnen",
  
  // Popular Topics
  topics_title: "Alles, was Sie über CSSBuy wissen müssen",
  topic_review_title: "CSSBuy Review",
  topic_review_desc: "Sehen Sie, wie es funktioniert, wichtige Funktionen, Einschränkungen und wichtige Faktoren.",
  topic_shipping_title: "CSSBuy Shipping Cost",
  topic_shipping_desc: "Verstehen Sie die wichtigsten Faktoren, die die endgültigen Versandkosten beeinflussen.",
  topic_coupon_title: "CSSBuy Coupon",
  topic_coupon_desc: "Erfahren Sie, wie Sie aktuelle Angebote finden und überprüfen.",
  topic_discount_title: "CSSBuy Discount Code",
  topic_discount_desc: "Lernen Sie, Codes und Bedingungen vor der Verwendung zu überprüfen.",
  topic_warehouse_title: "CSSBuy Warehouse",
  topic_warehouse_desc: "Verstehen Sie Lagerung, QC und Bestellvorbereitung.",
  topic_legit_title: "CSSBuy Legit",
  topic_legit_desc: "Lernen Sie die wichtigsten Punkte kennen, die vor der Nutzung eines Dienstes analysiert werden sollten.",
  
  // Trust Section
  trust_title: "Information vor dem Kauf",
  trust_desc: "CSSBuyBR.info ist eine unabhängige Ressource. Wir sind nicht die offizielle CSSBuy-Website, verarbeiten keine Zahlungen und verkaufen keine Produkte. Unser Ziel ist es, nützliche Informationen für Recherche, Vergleich und Verbraucherbildung zu organisieren.",
  
  // Final CTA
  final_cta_title: "Bereit, das CSSBuy Spreadsheet zu erkunden?",
  final_cta_desc: "Beginnen Sie mit einer Kategorie, konsultieren Sie unsere Guides und bestätigen Sie immer die aktuellen Informationen vor dem Kauf.",
  final_cta_primary: "CSSBuy Spreadsheet erkunden",
  final_cta_secondary: "Main Website besuchen",
  
  // Article Page
  article_intro: "Einleitung",
  article_what_is: "Was ist CSSBuy Spreadsheet",
  article_how_to_use: "Wie man CSSBuy Spreadsheet nutzt",
  article_categories: "Hauptkategorien",
  article_shipping: "Versand und Kosten",
  article_qc: "QC und Überprüfung",
  article_tips: "Praktische Tipps",
  article_comparison: "Vergleich mit Alternativen",
  article_safety: "Sicherheit und Vorsichtsmaßnahmen",
  article_conclusion: "Fazit",
  
  // Meta
  meta_home_title: "CSSBuy Spreadsheet: Produkte, Guides und Kaufinformationen finden",
  meta_home_desc: "Erkunden Sie ein organisiertes CSSBuy Spreadsheet mit Produkten, Kategorien, Guides, QC, Versand, Gutscheinen und Sicherheitsinformationen für Ihre Recherche.",
  meta_article_title: "CSSBuy Spreadsheet: Kompletter Guide zum Finden und Vergleichen von Produkten",
  meta_article_desc: "Kompletter CSSBuy Spreadsheet Guide. Lernen Sie, wie Sie recherchieren, Kategorien vergleichen, QC überprüfen und Versandkosten verstehen, um mit mehr Vertrauen zu kaufen.",
  
  // Category URLs (same external URLs)
  cat_url_shoes: "https://kaspreadsheet.com/category-911-Shoes.html",
  cat_url_hoodies: "https://kaspreadsheet.com/search-912/name/Shoes.html",
  cat_url_tshirts: "https://kaspreadsheet.com/search-913/name/Shoes.html",
  cat_url_jackets: "https://kaspreadsheet.com/search-914/name/Shoes.html",
  cat_url_pants: "https://kaspreadsheet.com/search-915/name/Shoes.html",
  cat_url_headwear: "https://kaspreadsheet.com/search-916/name/Shoes.html",
  cat_url_sets: "https://kaspreadsheet.com/search-917/name/Shoes.html",
  cat_url_underwear: "https://kaspreadsheet.com/search-918/name/Shoes.html",
  cat_url_jersey: "https://kaspreadsheet.com/search-919/name/Shoes.html",
  cat_url_accessories: "https://kaspreadsheet.com/search-920/name/Shoes.html",
  cat_url_bags: "https://kaspreadsheet.com/search-921/name/Shoes.html",
  cat_url_belts: "https://kaspreadsheet.com/search-922/name/Shoes.html",
  cat_url_perfumes: "https://kaspreadsheet.com/search-923/name/Shoes.html",
  cat_url_other: "https://kaspreadsheet.com/search-924/name/Shoes.html",
  main_site_url: "https://kaspreadsheet.com",
};